module.exports = __webpack_public_path__ + "5eb30963ef522482aee7313237a874ec.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-112.cur
// module id = 436
// module chunks = 0